import React, { useState } from "react";
import styled from "styled-components";
import VirtualTable from "../../../components/custom/VirtualTable";
import useActivity from "./useActivity";
import { ActivityRow } from "./activityTypes";

const FilterBar = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    gap: 12px;
    margin-bottom: 16px;
`;
const Field = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;
const FieldLabel = styled.label`
    font-size: 12px;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: #64748b;
`;
const Input = styled.input`
    border-radius: 6px;
    border: 1px solid #e2e8f0;
    padding: 6px 10px;
    font-size: 14px;
`;
const ApplyButton = styled.button`
    border-radius: 6px;
    border: none;
    background: #3db264;
    color: #0f172a;
    font-size: 14px;
    font-weight: 500;
    padding: 7px 14px;
    cursor: pointer;
`;

export default function ActivityView() {
    const { activity, filters, setFilters } = useActivity();
    const [action, setAction] = useState(filters.action ?? "");
    const [unit, setUnit] = useState(filters.unit ?? "");
    const [from, setFrom] = useState(filters.from ?? "");
    const [to, setTo] = useState(filters.to ?? "");

    const applyFilters = () => {
        setFilters({
            action: action || undefined,
            unit: unit || undefined,
            from: from || undefined,
            to: to || undefined,
        });
    };

    return (
        <div>
            <FilterBar>
                <Field>
                    <FieldLabel>Action</FieldLabel>
                    <Input value={action} onChange={(e) => setAction(e.target.value)} placeholder="e.g. assign" />
                </Field>
                <Field>
                    <FieldLabel>Unit</FieldLabel>
                    <Input value={unit} onChange={(e) => setUnit(e.target.value)} placeholder="e.g. CEWR1" />
                </Field>
                <Field>
                    <FieldLabel>From</FieldLabel>
                    <Input type="date" value={from} onChange={(e) => setFrom(e.target.value)} />
                </Field>
                <Field>
                    <FieldLabel>To</FieldLabel>
                    <Input type="date" value={to} onChange={(e) => setTo(e.target.value)} />
                </Field>
                <ApplyButton onClick={applyFilters}>Apply</ApplyButton>
            </FilterBar>

            <VirtualTable<ActivityRow>
                data={activity}
                mapping={[
                    { name: "When", value: "createdAt", datetime: true },
                    { name: "Who", value: "actorName" },
                    { name: "What", value: "summary" },
                ]}
            />
        </div>
    );
}
